// extracted by mini-css-extract-plugin
export default {"form":"style_form__SnngU","recover":"style_recover__O2vJJ","head":"style_head__7zYRV","goback":"style_goback__RR+6N"};